import { Record } from 'immutable';
import ObjectTypeKeys from 'automation-ui-references/object-types/ObjectTypeKeys';
import { getObjectTypeId, isCustomObject, getLabelByPrimaryDisplayLabel, getDefaultSearchPropertyNames, getSecondaryDisplayLabels, getFeedbackSubmissionTimestamp } from 'automation-ui-references/object-types/objectTypeUtils';
import { CONTACT_ID, FEEDBACK_SUBMISSION_ID } from 'automation-ui-references/object-types/CRMObjectTypes';
import { toFullNameAndEmail } from 'automation-ui-references/transform/transformContact';
export default class ObjectType extends Record({
  [ObjectTypeKeys.ID]: null,
  // [ObjectTypeKeys.CREATE_DATE_PROPERTY_NAME]: null,
  // [ObjectTypeKeys.LAST_MODIFIED_PROPERTY_NAME]: null,
  // [ObjectTypeKeys.PIPELINE_PROPERTY_NAME]: null,
  // [ObjectTypeKeys.PIPELINE_STAGE_PROPERTY_NAME]: null,
  // [ObjectTypeKeys.PIPELINE_CLOSE_DATE_PROPERTY_NAME]: null,
  // [ObjectTypeKeys.PIPELINE_TIME_TO_CLOSE_PROPERTY_NAME]: null,
  [ObjectTypeKeys.PRIMARY_DISPLAY_LABEL]: '',
  [ObjectTypeKeys.SECONDARY_DISPLAY_LABELS]: null,
  [ObjectTypeKeys.NAME]: null,
  [ObjectTypeKeys.META_TYPE]: null,
  [ObjectTypeKeys.META_TYPE_ID]: null,
  // [ObjectTypeKeys.HAS_CUSTOM_PROPERTIES]: null,
  // [ObjectTypeKeys.HAS_DEFAULT_PROPERTIES]: null,
  // [ObjectTypeKeys.HAS_PUBLIC_API]: null,
  // [ObjectTypeKeys.HAS_PIPELINES]: null,
  // [ObjectTypeKeys.HAS_OWNERS]: null,
  // [ObjectTypeKeys.IS_ASSET]: null,
  // [ObjectTypeKeys.HAS_EXTERNAL_OBJECT_IDS]: null,
  // [ObjectTypeKeys.RESTORABLE]: null,
  // [ObjectTypeKeys.INDEXED_FOR_FILTERS_AND_REPORTS]: null,
  [ObjectTypeKeys.DEFAULT_SEARCH_PROPERTY_NAMES]: null,
  [ObjectTypeKeys.REQUIRED_PROPERTIES]: [],
  // [ObjectTypeKeys.OBJECT_SUMMARY_PROPERTY_NAMES]: null,
  // [ObjectTypeKeys.INTEGRATION_APP_ID]: null,
  // [ObjectTypeKeys.OWNER_PORTAL_ID]: null,
  [ObjectTypeKeys.SINGULAR_FORM]: null,
  [ObjectTypeKeys.PLURAL_FORM]: null,
  // [ObjectTypeKeys.READ_SCOPE_NAME]: null,
  // [ObjectTypeKeys.WRITE_SCOPE_NAME]: null,
  // [ObjectTypeKeys.ACCESS_SCOPE_NAME]: null,
  // [ObjectTypeKeys.JANUS_GROUP]: null,
  // [ObjectTypeKeys.PERMISSIONING_TYPE]: null,
  // [ObjectTypeKeys.SCOPE_MAPPINGS]: null,
  [ObjectTypeKeys.FULLY_QUALIFIED_NAME]: null
}, 'ObjectType') {
  getPrimaryDisplayLabelProperty() {
    return this[ObjectTypeKeys.PRIMARY_DISPLAY_LABEL];
  }
  getObjectTypeId() {
    return getObjectTypeId(this);
  }
  isCustomObject() {
    return isCustomObject(this.getObjectTypeId());
  }
  getCustomLabel(object) {
    switch (this.getObjectTypeId()) {
      case CONTACT_ID:
        return toFullNameAndEmail(object);
      case FEEDBACK_SUBMISSION_ID:
        return `${getLabelByPrimaryDisplayLabel(this)(object)} (${getFeedbackSubmissionTimestamp(object)})`;
      default:
        return null;
    }
  }
  getLabel(object) {
    return this.getCustomLabel(object) || getLabelByPrimaryDisplayLabel(this)(object) || '';
  }
  getSearchProperties() {
    return getDefaultSearchPropertyNames(this);
  }
  getSecondaryDisplayLabels() {
    return getSecondaryDisplayLabels(this);
  }
}